// extracted by mini-css-extract-plugin
export var dateTimeButton = "_ip-1";
export var dateTimeButtonsContainer = "_ip-6";
export var dateTimeInputContainer = "_ip-7";
export var dateTimeWrapper = "_ip-8";
export var disabledTile = "_ip-0";
export var header = "_ip-2";
export var line = "_ip-3";
export var snoozeOption = "_ip-4";
export var time = "_ip-5";
export var todayTile = "_ip-9";
export var wrapper = "_ip-a";